module.exports = __webpack_public_path__ + "img/loading.43345842.svg";